var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"wp-like-sub-menu"},_vm._l((_vm.subMenuItemsData),function(menuItem){return _c('WPLikeSubMenuItem',{attrs:{"submenuItemData":menuItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }